import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DataCell, CommonModal } from '../../TableUIKit';
import { useEmailApi } from '../../auth/helper/api/emailApi';

const EmailNotificationSentPage = () => {




  const emailApi = useEmailApi();

  const [emailNotifications, setEmailNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // State for filters
  const [filters, setFilters] = useState({
    clientRequestId: null,
    groupRequestId: null,
    emailCategory: sessionStorage.getItem('emailCategory') || '', // Retrieve from sessionStorage
    emailBodyType: sessionStorage.getItem('emailBodyType') || '', // Retrieve from sessionStorage
    emailTemplateName: sessionStorage.getItem('emailTemplateName') || '', // Retrieve from sessionStroage
    status: sessionStorage.getItem('status') === 'true' ? true : (sessionStorage.getItem('status') === 'false' ? false : null), // Retrieve from sessionStorage    
    createdAt: null, // Date picker
    sentAt: null, // Date picker
    futureDate: null, // Date picker
  });

  // State for filter options
  const [emailCategories, setEmailCategories] = useState([]);
  const [emailBodyTypes, setEmailBodyTypes] = useState([]);
  const [emailTemplateNames, setEmailTemplateNames] = useState([]);

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages

  const [editingNotification, setEditingNotification] = useState(null);
  const [editFutureDate, setEditFutureDate] = useState('');
  const [editRePick, setEditRePick] = useState('');

  const [activeDetails, setActiveDetails] = useState(null);

  useEffect(() => {


    const fetchFilterOptions = async () => {
      try {
        const response = await emailApi.get(
          process.env.REACT_APP_GET_ALL_EMAIL_TEMPLATES_ENDPOINT
        );
        const { object } = response.data; // Assuming the response structure contains an array of template objects

        // Extracting necessary values for dropdowns
        const emailCategories = [...new Set(object.map(template => template.emailNotificationCategoryEntity.emailCategory))]; // email category which is linked to template
        const bodyTypes = [...new Set(object.map(template => template.emailBodyType))]; // Unique body types
        const emailTemplateNames = [...new Set(object.map(template => template.emailTemplateName))]; // template names

        // Set these unique values to state
        setEmailCategories(emailCategories);
        setEmailBodyTypes(bodyTypes);
        setEmailTemplateNames(emailTemplateNames);
      } catch (err) {
        setError(err.message || 'Error fetching filter options.');
      }
    };
    fetchFilterOptions(); // Call to fetch options
  }, [emailApi]); // Runs once when the component mounts

  useEffect(() => {


    const fetchEmailNotifications = async () => {
      setLoading(true); // Always set loading before a fetch
      try {
        const response = await emailApi.get(
          process.env
            .REACT_APP_GET_EMAIL_NOTIFICATION_DETAILS_BY_PAGE_ENDPOINT,
          {
            params: {
              ...filters, ...filters,
              page,
              size,
            },
          }
        );

        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) {
          setEmailNotifications(object.content); // Set the emailnotification from the response object
          setTotalPages(object.totalPages); // Update total pages from response
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        setError(err.message || 'An unexpected error occurred.');
        setLoading(false);
      }
    };

    fetchEmailNotifications(); // Fetch emails on component load
  }, [emailApi, page, size]); // Add an empty dependency array to call on mount



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      // Store the selected values in localStorage
      sessionStorage.setItem(name, value);
      return newFilters;
    });
  };

  const handleDateChange = (date, fieldName) => {
    setFilters((prev) => ({
      ...prev,
      [fieldName]: date,
    }));
  };

  const handleEditClick = (notification) => {
    // Set the notification being edited
    setEditingNotification(notification.id);
    setEditRePick(notification.rePick)//set rePick status to edit
    setEditFutureDate(
      notification.futureDate ? new Date(notification.futureDate) : null
    ); // Set the futureDate to edit
  };

  const handleEditSubmit = async (notificationId) => {

    try {
      // Update notification with PUT request
      await emailApi.put(
        `${process.env.REACT_APP_SET_EMAIL_NOTIFICATION_DETAILS_ENDPOINT}/${notificationId}`,
        {
          rePick: editRePick,
          futureDate: editFutureDate,
        }
      );

      // Refresh the templates list after the update
      const updatedNotification = emailNotifications.map((notification) => {
        if (notification.id === notificationId) {
          return { ...notification, rePick: editRePick, futureDate: editFutureDate }; // Update the edited notification
        }
        return notification; // Keep the other records unchanged
      });
      setEmailNotifications(updatedNotification);
      setEditingNotification(null); // Reset editing state
      setEditRePick('')//clear
      setEditFutureDate(''); // clear
    } catch (err) {
      setError(err.message || 'An error occurred while updating the Template.');
    }
  };

  const toggleActivationStatus = async (notificationId, currentStatus) => {

    try {
      const newStatus = !currentStatus; // Toggle activation status
      await emailApi.patch(
        `${process.env.REACT_APP_SET_EMAIL_NOTIFICATION_STATUS_ENDPOINT}/${notificationId}`,
        { status: newStatus }
      );
      // Update the local state after toggling the status
      setEmailNotifications((prev) => prev.map(notification =>
        notification.id === notificationId ? { ...notification, status: newStatus } : notification
      ));
    } catch (err) {
      setError(err.message || 'An error occurred while updating the status.');
    }
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'sent' ? true : value === 'not-sent' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, status: statusValue };
      // Store the status in localStorage
      sessionStorage.setItem('status', statusValue);
      return newFilters;
    });
  };

  // New function to apply filters
  const applyFilters = async () => {

    setLoading(true); // Show loading while fetching filtered notifications
    try {

      const response = await emailApi.get(
        process.env
          .REACT_APP_GET_EMAIL_NOTIFICATION_DETAILS_BY_PAGE_ENDPOINT,
        {
          params: {// Send filters as query parameters
            ...filters,
            page,// Add current page
            size,// Add items per page
          },
        }
      );

      const { message, object, httpStatus } = response.data;

      if (httpStatus === 200) {
        setEmailNotifications(object.content); // Set the emailnotification from the response object
        setTotalPages(object.totalPages); // Update total pages from response
      } else {
        setError(`Error: ${message}`); // Handle non-success status code
      }

    } catch (err) {
      setError(err.message || 'Failed to fetch notifications.');
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const handleNextPage = () => {
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error fetching email notifications: {error.message}</div>;

  return (
    <div className="page-container">
      <h1>Email Notifications</h1>
      <div className="flex-row filter-section">
        <div className='filter-item'>
          <label htmlFor="items-per-page">Items per page: </label>
          <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
            <option value={3}>default</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>
      <h3>Filters</h3>
      {/* Filter Form */}
      <div className="flex-row filter-section">
        <div className="filter-item">
          <label>ClientRequestId:</label>
          <input
            type="text"
            name="clientRequestId"
            value={filters.clientRequestId ?? ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="filter-item">
          <label>GroupClientRequestId:</label>
          <input
            type="text"
            name="groupRequestId"
            value={filters.groupRequestId ?? ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Email Category:</label>
          <select name="emailCategory" onChange={handleInputChange} value={filters.emailCategory}>
            <option value="">All</option>
            {emailCategories.map((emailCategory, index) => (
              <option key={index} value={emailCategory}>
                {emailCategory}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label>Email Template Name:</label>
          <select name="emailTemplateName" onChange={handleInputChange} value={filters.emailTemplateName}>
            <option value="">All</option>
            {emailTemplateNames.map((emailTemplateName, index) => (
              <option key={index} value={emailTemplateName}>
                {emailTemplateName}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label>Email Body Type:</label>
          <select name="emailBodyType" onChange={handleInputChange} value={filters.emailBodyType}>
            <option value="">All</option>
            {emailBodyTypes.map((type, index) => (
              <option key={index} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label>Status:</label>
          <select name="status" onChange={handleStatusChange} value={filters.status === null ? '' : filters.status ? 'sent' : 'not-sent'}>
            <option value="">All</option>
            <option value="sent">Sent</option>
            <option value="not-sent">Not Sent</option>
          </select>
        </div>

        <div className="filter-item">
          <label>Created At:</label>
          <DatePicker
            selected={filters.createdAt}
            onChange={(date) => handleDateChange(date, 'createdAt')}
            dateFormat="yyyy-MM-dd" // Adjust format as needed
            isClearable
            placeholderText="Select a date"
          />
        </div>

        <div className="filter-item">
          <label>Sent At:</label>
          <DatePicker
            selected={filters.sentAt}
            onChange={(date) => handleDateChange(date, 'sentAt')}
            dateFormat="yyyy-MM-dd" // Adjust format as needed
            isClearable
            placeholderText="Select a date"
          />
        </div>

        <div className="filter-item">
          <label>Future Date:</label>
          <DatePicker
            selected={filters.futureDate}
            onChange={(date) => handleDateChange(date, 'futureDate')}
            dateFormat="yyyy-MM-dd" // Adjust format as needed
            isClearable
            placeholderText="Select a date"
          />
        </div>

        <button type="button" onClick={applyFilters}>Apply Filters</button>

      </div>

      <h3>Email Notifications Status</h3>

      <div className="table-responsive">
        <table className="notifications-table">
          <thead>
            <tr>
              <th>id</th>
              <th>Client Request ID</th>
              <th>Group Request ID</th>
              <th>Email Category</th>
              <th>Email Subject</th>
              <th>Email Template Body</th>
              <th>Email Template Name</th>
              <th>Email Body Type</th>
              <th>From Email</th>
              <th>To Emails</th>
              <th>Cc Emails</th>
              <th>Bcc Emails</th>
              <th>Status</th>
              <th>Re Pick</th>
              <th>Actual Email Body Sent</th>
              <th>Created At</th>
              <th>Sent At</th>
              <th>Last Updated At</th>
              <th>Last Updated By</th>
              <th>Client Request ID</th>
              <th>Group Request ID</th>
              <th>Future Date</th>
              <th>JSON Data</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {emailNotifications.map((notification) => (
              <tr key={notification.id}>
                <td>{notification.id}</td>
                <td>{notification.clientRequestId}</td>
                <td>{notification.groupRequestId}</td>
                <td>{notification.emailCategory}</td>
                <td>{notification.emailSubject}</td>
                <DataCell label="EmailTemplateBody" value={notification.emailTemplateBody} onClick={setActiveDetails} />
                <td>{notification.emailTemplateName}</td>
                <td>{notification.emailBodyType}</td>
                <td>{notification.fromEmailId}</td>
                <DataCell label="To Email IDs" value={notification.toEmailIds} onClick={setActiveDetails} />
                <td>{notification.toCCEmailIds}</td>
                <td>{notification.toBCCEmailIds}</td>
                <td>{notification.status ? 'Sent' : 'Not Sent'}</td>
                <td>
                  {editingNotification === notification.id ? (
                    <select
                      value={
                        editRePick === null
                          ? ""
                          : editRePick
                            ? "true"
                            : "false"
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === "") {
                          setEditRePick(null);
                        } else {
                          setEditRePick(val === "true");
                        }
                      }}
                    >
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </select>
                  ) : (
                    // display value when not editing
                    notification.rePick ? "True" : "False"
                  )}
                </td>
                <DataCell label="ActualEmailBodySent" value={notification.actualEmailBodySent} onClick={setActiveDetails} />
                <td>{new Date(notification.createdAt).toLocaleString()}</td>
                <td>{new Date(notification.sentAt).toLocaleString()}</td>
                <td>{new Date(notification.lastUpdatedAt).toLocaleString()}</td>
                <td>{notification.lastUpdatedBy}</td>
                <td>{notification.clientRequestId}</td>
                <td>{notification.groupRequestId}</td>
                <td>
                  {editingNotification === notification.id ? (
                    <DatePicker
                      selected={editFutureDate}
                      onChange={(date) => setEditFutureDate(date)}
                      dateFormat="yyyy-MM-dd"
                      isClearable
                      placeholderText="Select a date"
                    />
                  ) : (
                    notification.futureDate ? new Date(notification.futureDate).toLocaleString() : 'N/A'
                  )}
                </td>
                <DataCell label="jsonData" value={notification.jsonData} onClick={setActiveDetails} />
                <td>
                  <div className="action-buttons">
                    {editingNotification === notification.id ? (
                      <button type="button" onClick={() => handleEditSubmit(notification.id)}>Save</button>
                    ) : (
                      <button type="button" onClick={() => handleEditClick(notification)}>Edit</button>
                    )}
                    <button type="button" onClick={() => toggleActivationStatus(notification.id, notification.status)}>
                      {notification.status ? 'Disable' : 'Enable'}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
      {/* ONE MODAL TO RULE THEM ALL */}
      <CommonModal
        isOpen={!!activeDetails}
        onClose={() => setActiveDetails(null)}
        /* Pull the dynamic title from state */
        title={activeDetails?.title || "Details"}
        copyValue={activeDetails?.text}
      >
        {activeDetails?.text}
      </CommonModal>
    </div>
  );
};

export default EmailNotificationSentPage;
